import { render } from "./ScheduleItems.vue?vue&type=template&id=0deb7820&scoped=true"
import script from "./ScheduleItems.vue?vue&type=script&lang=js"
export * from "./ScheduleItems.vue?vue&type=script&lang=js"

import "./ScheduleItems.vue?vue&type=style&index=0&id=0deb7820&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0deb7820"]])

export default __exports__